

































import EditionModal from "../core/Modals/EditionModal.vue";
import { EmployeApi } from "../api/EmployeApi";
import { Employe } from "../models/Employe";
import Planning = Employe.Planning;
import PlanningModalEdit from "./PlanningModalPartials/PlanningModalEdit.vue";
import PlanningModalSelectCopy from "./PlanningModalPartials/PlanningModalSelectCopy.vue";

export default {
    name: "PlanningModal",
    components: { PlanningModalSelectCopy, PlanningModalEdit, EditionModal },
    props: {
        employeId: Number,
        planningId: Number,
        isNew: Boolean,
    },
    data() {
        return {
            showModal: false,
            planning: null,
            fetching: true,
            editing: false,
            saving: false,
            EmployeApi: new EmployeApi(),
            Steps: {
                Selection: 0,
                Copy: 1,
                Edit: 2,
            },
            currentStep: 0,
        };
    },
    created() {
        this.currentStep = this.Steps.Selection;
    },
    methods: {
        closeModal: function (): void {
            this.showModal = false;
            this.$emit("close-modal");
        },
        creationModal: function (): void {
            this.showModal = true;
            this.fetching = false;
            this.editing = true;
        },
        onPlanningSelect(planning: Planning) {
            this.planning.planning_working_hours =
                planning.planning_working_hours;
        },
        savePlanning: function (): void {
            let self = this;
            if (self.saving || self.currentStep !== self.Steps.Edit) {
                if (self.currentStep === self.Steps.Copy) {
                    self.currentStep = self.Steps.Edit;
                }
                return;
            }
            if (self.planning.planning_working_hours.length === 0) {
                swal(
                    "Erreur",
                    "Vous devez entrer au moins une plage horaire",
                    "error"
                );
                return;
            }

            self.saving = true;
            self.EmployeApi.savePlanning(self.employeId, self.planning).then(
                function (res) {
                    self.saving = false;
                    self.closeModal();
                },
                function (err) {
                    self.saving = false;
                    swal(
                        "Erreur",
                        "Une erreur est survenue lors de la sauvegarde",
                        "error"
                    );
                }
            );
        },
    },
    watch: {
        isNew: {
            immediate: true,
            handler: function (newVal): void {
                if (newVal) {
                    this.planning = new Planning({});
                    this.currentStep = this.Steps.Selection;
                    this.creationModal();
                }
            },
        },
        planningId: {
            immediate: true,
            handler: function (newVal): void {
                let self = this;
                if (newVal) {
                    self.fetching = true;
                    self.EmployeApi.getPlanning(
                        self.employeId,
                        self.planningId
                    ).then(function (res) {
                        self.planning = res;
                        self.fetching = false;
                        self.currentStep = self.Steps.Edit;
                        self.showModal = true;
                        self.editing = true;
                    });
                }
            },
        },
    },
};
